{/* Auto-generated icon - do not edit */}
import React from 'react'

interface GenderlessIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const GenderlessIcon = React.forwardRef<SVGSVGElement, GenderlessIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 78 78"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M76.8386 39.3932C76.9443 45.4374 75.7983 51.4382 73.4736 57.0185C69.9615 65.7904 63.7172 71.6639 54.644 74.4114C45.9313 77.1627 36.6582 77.6333 27.7117 75.7779C15.0346 73.0908 6.8908 65.2504 2.83659 53.1685C-1.42633 40.4612 -0.46672 28.1501 6.85471 16.7101C8.47396 14.2868 10.4722 12.1394 12.773 10.3502C18.9261 5.42768 25.9956 2.62113 33.8415 1.39575C42.1074 0.104734 49.9321 1.53704 57.5882 4.31466C61.9155 5.88462 65.1764 9.07307 67.8868 12.7262C73.807 20.708 77.0841 29.6006 76.8386 39.3932ZM37.2017 8.79623C28.1357 9.41909 25.0405 10.3418 19.6296 13.6143C15.8388 15.846 12.7474 19.0929 10.7037 22.9882C5.23112 33.3728 6.13929 43.8024 10.4521 54.1771C13.9418 62.5737 20.4135 67.5566 29.3154 69.3162C37.4422 70.9223 45.4212 70.0848 53.206 67.4384C58.0806 65.7818 61.9872 62.6709 64.1872 58.0299C70.5325 44.6406 70.0659 31.5617 61.5843 19.1307C59.6791 16.1812 56.9684 13.8397 53.7736 12.383C48.0412 9.90859 42.0317 8.70828 37.2017 8.79623Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="77.4479" height="76.7915" fill={color} transform="translate(0.0307617 0.569824)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

GenderlessIcon.displayName = 'GenderlessIcon'
